import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-transition/src/selection/interrupt.js
// module id = SZC4
// module chunks = 0